import { useDrawer } from 'src/hooks/useDrawer';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { FC, SyntheticEvent, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import CloseBannerIcon from 'src/modules/catchGame/svg/CloseBannerIcon';
import { useRoute } from 'src/router/hooks/useRoute';
import { Button } from 'src/components/Buttons/Button';
import { BANNER_SETTINGS } from '../config';
import { PromoGameTimer } from './components/PromoGameTimer';
import dayjs from 'dayjs';
import { EventGamesType } from 'src/config/event/types';

type PromoGameBannerProps = { gameNameFromProps?: EventGamesType };

export const PromoGameBanner: FC<PromoGameBannerProps> = ({ gameNameFromProps }) => {
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(true);
  const [date, setDate] = useState(0);
  const { ROUTE } = useRoute();
  const { closeDrawer } = useDrawer();
  const { t } = useTranslation();
  const gameName = useMemo(() => {
    if (gameNameFromProps) return gameNameFromProps;
    return Object.values(BANNER_SETTINGS).find((game) => game.checkShowBanner())
      ?.key as EventGamesType;
  }, [gameNameFromProps]);

  useEffect(() => {
    setDate(Math.floor(dayjs(dayjs().format('YYYY-MM-DD')).valueOf()));
  }, []);

  if (!gameName) return null;

  const handlerBannerClick = () => {
    closeDrawer();
    navigate(ROUTE[gameName].get());
  };
  const handleBannerClose = (e: SyntheticEvent) => {
    e.stopPropagation();
    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <div className="flex w-full max-w-[1280px] justify-end m-auto pr-3 mb-5">
          <div
            className={classNames(
              'w-[265px] h-[142px] overflow-hidden relative cursor-pointer pt-[34px] self-end pointer-events-auto'
            )}
            onClick={handlerBannerClick}>
            <img
              src={BANNER_SETTINGS[gameName].promoImgSrc}
              className="w-auto h-[108px] object-contain absolute bottom-0 left-0 rounded-[10px]"
            />
            <div
              onClick={handleBannerClose}
              className="rounded-3xl p-1 absolute top-0 right-0 bg-gb_promo_banner_close_bg w-6 h-6 flex justify-center items-center">
              <CloseBannerIcon fill="gb_promo_banner_close_cross" />
            </div>
            <div
              className={classNames(
                'rounded-lg w-full h-full pl-[115px] border border-gb_banner_border py-2 pr-3 flex flex-col gap-1 justify-between',
                BANNER_SETTINGS[gameName].bgPopupColor
              )}>
              <p className="text-gb_banner_text font-bold text-sm uppercase">
                {t(BANNER_SETTINGS[gameName].namePopup)}
              </p>
              <PromoGameTimer dateEnd={date} />
              <Button title={t('general.play') as string} className="w-fit min-w-[100px]">
                {t('general.play')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
